import Screenshots from './screenshots';
import AppleStore from './apple-store';
import PlayStore from './play-store';

export default {
  Screenshots,
  AppleStore,
  PlayStore,
};
